import { Container } from 'pixi.js';
import { EventEmitter, Vibrator } from '../core';
import { Vector, Point, Updatable, Transitionable } from '../interface';

abstract class BaseObject extends EventEmitter implements Updatable, Transitionable {
  public container: Container;
  public velocity: Vector;
  public position: Point;

  protected readonly vibrator: Vibrator;
  protected readonly ui: Container;
  protected readonly stage: Container;

  constructor() {
    super();
    this.container = new Container();
    this.ui = new Container();
    this.stage = new Container();
    this.velocity = { x: 0, y: 0 };
    this.position = { x: 0, y: 0 };

    this.vibrator = new Vibrator(this.stage);
    this.container.addChild(this.stage);
    this.container.addChild(this.ui);

    this.on('transition', (prevState: string, nextState: string) => this.transition(prevState, nextState));
  }

  public abstract transition(prevState: string, nextState: string): void;

  public update(elapsed: number): void {
    this.applyVelocity(elapsed);
    this.applyPosition();
    this.vibrator.update(elapsed);
  }

  private applyVelocity(elapsed: number): void {
    this.position.x += this.velocity.x * elapsed;
    this.position.y += this.velocity.y * elapsed;
  }

  private applyPosition(): void {
    this.container.x = this.position.x;
    this.container.y = this.position.y;
    this.stage.x = 0;
    this.stage.y = 0;
    this.ui.x = 0;
    this.ui.y = 0;
  }

  protected updateZIndex(): void {
    this.container.zIndex = this.container.y;
  }

  public destroy(): void {
    super.destroy();
    this.stage.removeChild(this.stage.parent);
    this.ui.removeChild(this.ui.parent);
  }
}

export default BaseObject;
